export default __webpack_public_path__ + "static/media/omnes_medium-webfont.0beee264.woff";